import React from 'react';
import { NavLink, useHistory } from 'react-router-dom';
import { getSession, logout } from '../services/auth';
import './NavMenu.css';

export function NavMenu() {
  const history = useHistory();
  const session = getSession();

  function handleLogout() {
    logout();
    history.push('/login');
  }

  return (
    <nav className="sidebar d-flex flex-column">
      <div className="sidebar-brand">
        <span className="brand-icon">&#128273;</span>
        <span className="brand-text">SeikoAuth</span>
        <small className="brand-sub">Admin</small>
      </div>

      <ul className="sidebar-nav flex-grow-1">
        <li className="nav-section">OVERVIEW</li>
        <li>
          <NavLink exact to="/" className="sidebar-link" activeClassName="active">
            <span className="nav-icon">&#9632;</span>
            Dashboard
          </NavLink>
        </li>
        <li className="nav-section">MANAGEMENT</li>
        <li>
          <NavLink to="/clients" className="sidebar-link" activeClassName="active">
            <span className="nav-icon">&#128193;</span>
            Clients
          </NavLink>
        </li>
        <li>
          <NavLink to="/scopes" className="sidebar-link" activeClassName="active">
            <span className="nav-icon">&#128274;</span>
            Scopes
          </NavLink>
        </li>
        <li className="nav-section">SYSTEM</li>
        <li>
          <NavLink to="/settings" className="sidebar-link" activeClassName="active">
            <span className="nav-icon">&#9881;</span>
            Settings
          </NavLink>
        </li>
      </ul>

      <div className="sidebar-footer">
        {session && (
          <div className="sidebar-user">
            <span className="sidebar-username">&#128100; {session.username}</span>
            <button className="btn-logout" onClick={handleLogout} title="Se déconnecter">
              &#10132;
            </button>
          </div>
        )}
        <div style={{ marginTop: 8 }}>SeikoAuth &copy; {new Date().getFullYear()}</div>
      </div>
    </nav>
  );
}
